import { CREATE_INCENTIVE_SLAB } from "./type";

const initalState = {
    incentiveSlabRes: null,
};

const CreateIncentiveSlab = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CREATE_INCENTIVE_SLAB:
            return {
                ...state,
                incentiveSlabRes: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default CreateIncentiveSlab;
